import r from "react";
function t(t) {
  var e = t.img,
    a = t.altText,
    m = t.fallbackImg,
    n = !1;
  return "string" == typeof e ? r.createElement("img", {
    src: e,
    alt: a || "",
    onError: function onError(r) {
      n || (n = !0, r.target.src = m || "");
    }
  }) : e;
}
t.displayName = "Image";
export { t as Image };